import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  documentId: yup.number().required(),
  patientId: yup.number().required(),
  name: yup.string().required(),
  filename: yup.string().required(),
  doc_type: yup.string().required(),
  expiration_date: yup.string().nullable(),
  description: yup.string().nullable(),
});

export function usePatientDocumentUpdateMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.patch(
        HTTP_ENDPOINTS.patientDocuments.update(req.documentId),
        {
          patient_id: req.patientId,
          name: req.name,
          filename: req.filename,
          doc_type: req.doc_type,
          expiration_date: req.expiration_date,
          description: req.description,
        },
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.all],
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.one],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
